export enum GameSessionStatus {
	Lobby = "lobby",
	Active = "active",
	Completed = "completed",
}

export enum GameStartMode {
	Admin = "admin",
	Player = "player",
	Scheduled = "scheduled",
}
